<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.08</b> - Стабильность, производительность и полировка</p>
    <ul class="ml-5 pb-4 list-outside list-disc text-purple-500">
      <li>Бесшовные переходы между комнатами Пещеры; исправления прицеливания ИИ для ракет и ближнего боя.</li>
      <li>Исправлены бусты опыта героев при активации из полного рюкзака.</li>
      <li>Оптимизация рендеринга боя и памяти для более плавной игры.</li>
      <li>Визуальные исправления: Маска дьявола, бафф вдохновение, границы; настроена анимация peanuts.</li>
      <li>Исправлен краш таблицы лидеров.</li>
    </ul>
  </div>
</template>
